export default {
  text: {
    order_cancelled: 'Bestelling geannuleerd - Geen chauffeur beschikbaar',
    wolt_support: 'Vragen? Bel Wolt rechtstreeks <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT:</strong> Accepteer of weiger deze bestelling onmiddellijk',
  },
  labels: {
    dummy_order: 'Testbestelling',
    items_one: '{{count}} artikel',
    items_other: '{{count}} artikelen',
    needs_acceptance: 'Acceptatie vereist',
    driver_pending: 'Wachten op chauffeur',
    today: 'Vandaag',
    driver_assigned: 'Chauffeur toegewezen',
    complete: 'Voltooid',
  },
  buttons: {
    complete_order: 'Markeer als voltooid',
    looking_for_driver: 'Op zoek naar een chauffeur...',
    click_to_remove: 'Klik om te verwijderen',
  },
};
